module.exports = __webpack_public_path__ + "img/CM-DJ-25-Nissan-Modern.1bca2433.jpg";